<div id="block-octa" class="content box dark">
    <!-- <fa-icon [icon]="boxFAIcon" class="ico"></fa-icon>
    <div class="splitter"></div> -->

    <a href="http://octa.academianewfight.com.br/" target="_blank" >
        <img class="octasvg" src="../assets/img/octa/octa-light.png" 
					style="opacity: 1; width: 72px; margin: 54px 0 18px;" />
    </a> 

    <h1 class="title">OCTA</h1>
    <p class="sub">WARRIORS<br/>ONLY</p>

    <br/><br/><br/>
    <a href="http://octa.academianewfight.com.br/" target="_blank"  class="btn-splatter">
        PORTAL DO ALUNO
    </a>

</div>